import script from "./MenuCertificadosEDeclaracoesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCertificadosEDeclaracoesView.vue?vue&type=script&setup=true&lang=js"

import "./MenuCertificadosEDeclaracoesView.vue?vue&type=style&index=0&id=ae313954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae313954"]])

export default __exports__